<div class="grid-container">
  <form [formGroup]="form">
    <div class="grid-x grid-margin-x margin-top " [ngClass]="{ 'hideSection': currentStep != steps.SelectApplicationAndPayments }">
      <div class="cell large-4 medium-4 small-6 padding-right-small text-align-right bold">
        Search for an Application:<span [ngClass]="{ 'red': form.get('applicationNumber').invalid }">*</span>
      </div>
      <div class="cell large-4 medium-4 small-4 padding-right-small">
        <input type="text" formControlName="applicationNumber" />
      </div>
      <div class="cell large-4 medium-4 small-2 text-align-left">
        <span class="padding-right">
          <button class="button" (click)="searchApplications()" [disabled]="form.get('applicationNumber')?.invalid || searchInProgress">Search Applications</button>
        </span>
      </div>
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="searchingApplications?.value == true" [tickType]="'.'" [text]="'Searching Applications'" [interval]="1500"></text-loader>
      </div>
      @if (searchingApplications?.value == false) {
        @if (matchingApplications?.length > 0) {
          <div class="cell large-12 medium-12 small-12 margin-bottom">
            <ag-grid-angular class="data-grid " [rowData]="matchingApplications" [gridOptions]="applicationGridOptions" [selectionColumnDef]="selectionColumnDef" (selectionChanged)="applicationSelectionChanged($event)" aria-label="Request Payment Adjustment"></ag-grid-angular>
          </div>
        } @else {
          <div class="cell large-12 medium-12 small-12">
            @if (matchingApplications != null) {
              <span>There are no results that match your request.</span>
            }
          </div>
        }
      }
      @if (selectedApplication?.length > 0) {
        <div class="cell large-5 medium-5 small-6 text-align-right padding-right">
          Search for payments for application #{{selectedApplication}}?
        </div>
        <div class="cell large-7 medium-7 small-6 padding-left text-align-left">
          <button class="button" (click)="searchForPayments()" [disabled]="form.get('selectedApplication').invalid || searchInProgress">Search Payments</button>
        </div>
        <div class="cell large-12 medium-12 small-12">
          <text-loader [run]="searchingAppliedPayments?.value == true" [tickType]="'.'" [text]="paymentSearchText" [interval]="1000"></text-loader>
        </div>
        @if (currentPayments?.length > 0) {
          <div class="cell large-12 medium-12 small-12 bold">
            Select one or more payments to adjust:<span [ngClass]="{ 'red': form.get('paymentsToReapply').invalid }">*</span>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <ag-grid-angular class="data-grid " [rowData]="currentPayments" [gridOptions]="currentPaymentGridOptions" [groupDefaultExpanded]="-1" [selectionColumnDef]="selectionColumnDef" (selectionChanged)="paymentSelectionChanged($event)" aria-label="Request Payment Adjustment"></ag-grid-angular>
          </div>
          <div class=" cell large-12 medium-12 small-12 text-align-center margin-top">
            <button class="button" (click)="setStep(steps.ReassignPayments)" [disabled]="form.get('paymentsToReapply').invalid">Proceed to Reassignment</button>
          </div>
        } @else {
          <div class="cell large-12 medium-12 small-12">
            @if (currentPayments != null) {
              <span>
                Application #{{selectedApplication}} has no payments that are eligible for adjustment.<help-text [helpText]="helpText"></help-text>
              </span>
            }
          </div>
        }
      }
    </div>
    <div class="grid-x grid-margin-x margin-top" [ngClass]="{ 'hideSection': currentStep != steps.ReassignPayments }">
      <div class="cell small-12 large-12 medium-12 bold">
        Available Payment Methods:
      </div>
      <div class="cell large-6 medium-6 small-6 bold text-align-center">
        Payment Instrument
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Total Funds
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Applied Funds
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        RemainingFunds
      </div>
      @for (instrument of pendingInstruments; track instrument) {
        <div class="cell large-6 medium-6 small-6 text-align-left">
          {{instrument.instrumentDescription}}<span [ngClass]="{ 'hideSection': !instrument.hasError }"><svg-icon [icon]="icon-alert" [hoverText]="instrumentError"></svg-icon></span>
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{instrument.instrumentAmount | currency}}
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{instrument.appliedAmount | currency}}
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{instrument.fundsRemaining | currency}}
        </div>
      }
      <div class="cell large-12 medium-12 small-12 bold">
        Select an application requiring payments to be applied:
      </div>
      <div class="cell large-12 medium-12 small-12 margin-bottom">
        <ag-grid-angular class="data-grid " [rowData]="applicationsToBePaid" [gridOptions]="pendingPaymentGridOptions" [selectionColumnDef]="selectionColumnDef" (selectionChanged)="pendingPaymentSelectionChanged($event)" aria-label="Request Payment Adjustment"></ag-grid-angular>
      </div>
      @if (feeBeingAdjusted != null) {
        <div class="cell large-12 medium-12 small-12 bold">
          Reapply funds to: {{feeBeingAdjusted?.feeDescription}}
        </div>
        <div class="cell large-6 medium-6 small-6 bold padding-left text-align-right">
          Select Payment Source:
        </div>
        <div class="cell large-6 medium-6 small-6 bold padding-right text-align-left">
          @if (undisbursedInstruments?.length > 0) {
            <select formControlName="selectedSource">
              @for (inst of undisbursedInstruments; track inst) {
                <option [value]="inst.id">{{inst.instrumentDescription}}</option>
              }
            </select>
          } @else {
            There are no instruments with funds available to be applied.
          }
        </div>
      }
      @if (selectedSource != null) {
        <div class="cell large-3 medium-3 small-3 bold">
          Source:
        </div>
        <div class="cell large-3 medium-3 small-3 bold">
          Available Funds:
        </div>
        <div class="cell large-6 medium-6 small-6 bold">
          Funds to Apply:
        </div>
        <div class="cell large-3 medium-3 small-3">
          {{selectedSource.instrumentDescription}}
        </div>
        <div class="cell large-3 medium-3 small-3">
          {{selectedSource.fundsRemaining | currency}}
        </div>
        <div class="cell large-3 medium-3 small-3">
          <input type="number" formControlName="appliedAmount" min="0.01" />
        </div>
        <div class="cell large-3 medium-3 small-3">
          <button (click)="reapplyFunds()" class="button">Apply</button>
        </div>
      }
      <div class="cell large-12 medium-12 small-12 text-align-center">
        <button class="button" (click)="setStep(steps.ConfirmSelections)" [disabled]="disableConfirm">View Summary & Add Notes & Documentation</button>
      </div>
    </div>
    <div class="grid-x grid-margin-x margin-top" [ngClass]="{ 'hideSection': currentStep != steps.ConfirmSelections }">
      @if (currentStep == steps.ConfirmSelections) {
        <div class="cell large-12 medium-12 small-12 margin-bottom">
          <ag-grid-angular class="data-grid " [rowData]="pendingAdjustments" [gridOptions]="adjustmentGridOptions" aria-label="Request Payment Adjustment"></ag-grid-angular>
        </div>
      }
      <div class="cell large-12 medium-12 small-12 margin-top">
        <adjustment-request-notes [notes]="notes" [enabled]="true" (errorOccurred)="logError($event)" (noteAdded)="addNote($event)" (noteDeleted)="deleteNote($event)"></adjustment-request-notes>
      </div>
      <div class="cell large-12 medium-12 small-12 margin-top">
        Upload Supporting Documentation:<span class="padding-left">*All supporting documents will be attached to all selected adjustments.</span>
      </div>
      <div class="cell small-12 medium-12 large-12">
        <upload-view-files [uniqueId]="'uploader'" [files]="storedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="onFileDeleted($event)" (newFilesList)="onFileAdded($event)"></upload-view-files>
      </div>
      <div class="cell small-12 medium-12 large-12 text-align-center margin-top">
        <span class="padding-right">
          <button class="button" (click)="confirmRestart()">Cancel</button>
        </span>
        <span class="padding-left">
          <button class="button" (click)="submitRequest()" [disabled]="disableSubmit">Submit Request</button>
        </span>
      </div>
    </div>
  </form>

</div>




